import PropTypes from 'prop-types';
import React from 'react';
import { ClipboardCheck, PatchCheck, ShieldCheck } from 'react-bootstrap-icons';

import useTranslation from '../../hooks/use_translation';
import Trans from '../translation/trans';
import './bar-trust';

const BarTrust = ({
	color = 'light',
	single = false,
	size = 'lg',
	variant = 'horizontal',
}) => {
	const { t } = useTranslation('component_bar_trust');

	const buttons = [
		{ excerptKey: t('t4'), icon: <PatchCheck />, labelKey: 't1' },
		{ excerptKey: t('t5'), icon: <ShieldCheck />, labelKey: 't2' },
		{
			excerptKey: t('t6'),
			icon: <ClipboardCheck />,
			labelKey: 't3',
			show: !single,
		},
	];

	const variants = {
		cards: {
			item: 'bg-gray-100 rounded-3 p-3 w-100 gap-4 mb-2 mb-lg-0 d-flex flex-column ',
			wrapper: 'trust-cards col-lg-4 d-flex justify-content-center ',
		},
		horizontal: {
			item: 'd-flex gap-1 align-items-center',
			wrapper: 'col-lg-4 d-flex justify-content-center',
		},
		vertical: {
			wrapper:
				'd-flex flex-column align-items-center align-items-lg-start justify-content-center mb-2',
		},
	};

	const colors = {
		dark: { text: 'bar-trust-dark' },
		light: { text: 'bar-trust-light' },
	};

	const sizes = {
		lg: {
			iconSize: 'title-medium text-primary',
			labelSize: 'title-small mb-0',
		},
		md: { iconSize: 'md', labelSize: 'sm' },
		sm: { iconSize: 'sm', labelSize: 'xs' },
	};

	return (
		<div className="row">
			{buttons.map(
				(button, index) =>
					button.show !== false && (
						<div className={variants[variant].wrapper} key={index}>
							<div
								className={`${variants[variant].item} ${colors[color].text} `}
							>
								<span className={sizes[size].iconSize}>{button.icon}</span>
								<div>
									<span className={sizes[size].labelSize}>
										<Trans i18nKey={button.labelKey} t={t} />
									</span>
									{variant === 'cards' && (
										<p className="sm text-muted mb-0">{button.excerptKey}</p>
									)}
								</div>
							</div>
						</div>
					),
			)}
		</div>
	);
};

BarTrust.propTypes = {
	color: PropTypes.string,
	single: PropTypes.bool,
	size: PropTypes.string,
	variant: PropTypes.string,
};

export default BarTrust;
